export const skillCategories = [
  'Design & Creative Arts',
  'Marketing & Communications',
  'Business & Entrepreneurship',
  'Education & Coaching',
  'Health & Wellness',
  'Crafts & DIY',
  'Writing & Content Creation',
  'Languages & Translation',
  'Finance & Investment',
  'Science & Research',
  'Hospitality & Culinary Arts',
  'Legal & Administration',
  'Social Good & Nonprofit',
  'Sports & Recreation',
  'Pet Services',
  'Cleaning & Organization',
  'Home Maintenance & Repairs',
  'Event & Party Services',
  'Transportation & Delivery',
  'Gardening & Landscaping',
  'Personal Assistance',
  'Hair & Body Care',
  'Trades & Skilled Labour',
  'Entertainment & Performing Arts',
  'Agricultural & Farming Services',
  'Parenting & Childcare Services',
  'Automotive Services',
  'Technology & IT',
];
